/** Figma 5722:9554–5722:9568 — pulse bar heights (px) */
export const ACTIVITY_INTENSITY_BAR_HEIGHTS = [
  25.59, 32, 38.39, 44.8, 51.19, 57.59, 64, 70.39, 76.8, 83.19, 89.59, 96, 102.39, 108.8,
  115.19,
] as const

export const INTENSITY_PILL_GRADIENT =
  "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 78.667 32' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'><rect x='0' y='0' height='100%' width='100%' fill='url(%23grad)' opacity='0.3'/><defs><radialGradient id='grad' gradientUnits='userSpaceOnUse' cx='0' cy='0' r='10' gradientTransform='matrix(3.9333 0 0 1.6 39.333 16)'><stop stop-color='rgba(255,136,0,1)' offset='0.46635'/><stop stop-color='rgba(233,93,92,0.5)' offset='1'/></radialGradient></defs></svg>\")"
